module.exports = __webpack_public_path__ + "static/media/GraphikBold.8a604ed5.otf";